module.exports = __webpack_public_path__ + "static/services-quality-assurance-b89ef45fff652555222ffc8a2773f63e.svg";